import type { ReactElement } from 'react'
import { picture, wrapper } from './ProfilePicture.css'

export const ProfilePicture = ({ src }: { src: string }): ReactElement => {
  return (
    <span className={wrapper}>
      <img src={src} alt="Profil" className={picture} />
    </span>
  )
}
